import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Introduction from './components/Introduction';
import Services from './components/Services';
import Partners from './components/Partners';
import BlogPage from './components/BlogPage';
import BlogPost from './components/BlogPost';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { Routes, Route } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Header />
      <main className="page-main">
        <Routes>
          <Route path="/" element={<>
            <Hero />
            <Services />
            <Partners />
            <Introduction />
            <Contact />
          </>} />
          <Route path="/blog" element={<BlogPage/>} />
          <Route path="/blog/:slug" element={<BlogPost/>} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
